/**
 * Created by robert.lavoie on 6/15/17.
 */

import { Component, ChangeDetectionStrategy, Input, OnInit } from '@angular/core';

// Models
import {
  SiteColumn,
  VIDEO_PATTERN_VIMEO,
  VIDEO_PATTERN_YOUTUBE,
} from '../../models';

/**
 *
 * @class
 * CustomerSiteColumnVideoComponent
 *
 * @description
 * This component displays an video within a column
 *
 */
@Component({
  templateUrl: 'customer-site-column-video.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'customer-site-column-video',
  styleUrls: ['./customer-site-column-video.component.scss'],
})
export class CustomerSiteColumnVideoComponent implements OnInit {

  // The current column
  @Input() column: SiteColumn;

  // Bindings for the regular expressions we care about for videos
  private patternVimeo = VIDEO_PATTERN_VIMEO;
  private patternYouTube = VIDEO_PATTERN_YOUTUBE;

  // The binding we will use to show the video
  videoUrl;

  ngOnInit() {
    this.videoUrl = this.convertVideoUrl(this.column.videoUrl);
  }

  /**
   * converts the video url to the propper embed url
   *
   * @param { string }
   * @return { string }
   */
  private convertVideoUrl(url: string): string {

    // If we are dealing with an embed url already, return
    if (this.isEmbedUrl(url)) return url;

    let convertedUrl = url;

    if (this.patternVimeo.test(url)) {
      const replacement = '//player.vimeo.com/video/$1';
      convertedUrl = url.replace(this.patternVimeo, replacement);
    }

    if (this.patternYouTube.test(url)) {
      const replacement = '//www.youtube.com/embed/$1?rel=0';
      convertedUrl = url.replace(this.patternYouTube, replacement);
    }

    return convertedUrl;
  }

  /**
   * Determines if a given url is an embed URL or not
   * @param { string } url - the url to check
   * @returns { boolean }
   */
  private isEmbedUrl(url: string): boolean {
    // Setup some variables for handling logic
    let foundKeyword = false;
    const embedKeywords = [
      'player',
      'embed',
    ];

    // Filter the list based on the passed in URL, seeing if any match -- if they do set to true
    embedKeywords.filter(value => url.indexOf(value) >= 0).map(value => foundKeyword = true);

    // Return the result
    return foundKeyword;
  }

}
